(function () {
  // Prevent duplicate init
  if (window.__SKU_DESC_LOADED__) return;
  window.__SKU_DESC_LOADED__ = true;

  // Debug flag (enable with &sku-debug=1 or window.SKU_DESC_DEBUG = true)
  const __SKU_DEBUG__ = (function () {
    try {
      return /(?:^|[?&])sku-debug=1(?:&|$)/.test(location.search) || window.SKU_DESC_DEBUG === true;
    } catch (_) {
      return false;
    }
  })();

  // Throttled logger to avoid flooding
  let __SKU_LAST_LOG__ = 0;
  const __SKU_LOG_EVERY_MS__ = 1500;
  function debug() {
    if (!__SKU_DEBUG__) return;
    const now = Date.now();
    if (now - __SKU_LAST_LOG__ < __SKU_LOG_EVERY_MS__) return;
    __SKU_LAST_LOG__ = now;
    // eslint-disable-next-line no-console
    console.log.apply(console, ["[SKU-DESC]"].concat([].slice.call(arguments)));
  }

  // Data locations (injected via Liquid; fall back to asset paths)
  let JSON_URL = window.SKU_DESC_JSON_URL || "";
  let CSV_URL = window.SKU_DESC_CSV_URL || "";
  try {
    const thisScript =
      document.currentScript ||
      Array.from(document.scripts || []).find((s) => (s.src || "").indexOf("sku-descriptions.js") > -1);
    const base = thisScript && thisScript.src ? new URL(thisScript.src, window.location.origin).origin : "";
    if (!JSON_URL) JSON_URL = (base || "") + "/assets/sku-descriptions.json";
    if (!CSV_URL) CSV_URL = (base || "") + "/assets/shopify-descriptions-sku.csv";
  } catch (_) {
    if (!JSON_URL) JSON_URL = "/assets/sku-descriptions.json";
    if (!CSV_URL) CSV_URL = "/assets/shopify-descriptions-sku.csv";
  }

  function parseCSV(text) {
    const lines = text.split(/\r?\n/);
    const map = {};
    // Skip header (row 0)
    for (let i = 1; i < lines.length; i++) {
      const line = lines[i];
      if (!line || /^\s*$/.test(line)) continue;

      // Only split on the first comma (MPN,HTML)
      const idx = line.indexOf(",");
      if (idx === -1) continue;

      let key = line.slice(0, idx).trim();
      let val = line.slice(idx + 1).trim();

      // Unquote key / value and unescape double-quotes
      if (key.startsWith('"') && key.endsWith('"')) key = key.slice(1, -1);
      if (val.startsWith('"') && val.endsWith('"')) val = val.slice(1, -1);
      val = val.replace(/""/g, '"');

      if (key) map[key] = val;
    }
    // Ensure header key (if any) is dropped
    if (map.MPN) delete map.MPN;
    return map;
  }

  function ensureContainer() {
    let el = document.getElementById("variant-sku-description");
    if (el) return el;

    el = document.createElement("div");
    el.id = "variant-sku-description";
    el.className = "product__variant-description rte";
    el.style.margin = "24px 0";
    el.style.width = "100%";

    // Preferred anchors (Theme + PageFly)
    const pInfo = document.querySelector("product-info");
    const pfSwatches = document.querySelector('[data-pf-type="ProductVariantSwatches"]');
    const pfPrice = document.querySelector('[data-pf-type="ProductPrice2"]');
    const pfTabs = document.querySelector('[data-pf-type="Tabs3"]');
    const pfRoot = document.getElementById("__pf");
    
    // PageFly product column and its parent row (for full-width placement)
    const pfProductColumn = document.querySelector(".__pf.__pf_8dFv2jqG .pf-14_");
    // The row containing both image and product info columns (parent of the product column)
    const pfTwoColumnRow = pfProductColumn ? pfProductColumn.parentElement : null;
    // PageFly section container (one level up from row)
    const pfSection = document.querySelector(".__pf.__pf_8dFv2jqG");

    // For system products (Muto Systems): inject into the "Included" tab content area
    // The first tab content (pf-46_) is the "Included" tab
    const pfFirstTabContent = document.querySelector('.pf-tab3-content-container.pf-tab-5ee52ada-content-0 [data-pf-type="TabsContent3"]');
    const isSystemProduct = typeof window.PRODUCT_IS_SYSTEM !== 'undefined' && window.PRODUCT_IS_SYSTEM === true;
    
    // 0) System products: inject into "Included" tab content
    if (isSystemProduct && pfFirstTabContent) {
      pfFirstTabContent.appendChild(el);
      debug("Injected into Included tab content");
    }
    // 1) PageFly: inject AFTER the two-column row to wrap full-width beneath both columns
    else if (pfTwoColumnRow && pfTwoColumnRow.parentNode) {
      pfTwoColumnRow.parentNode.insertBefore(el, pfTwoColumnRow.nextSibling);
    }
    // 2) Fallback: append to PageFly section
    else if (pfSection) {
      pfSection.appendChild(el);
    }
    // 3) Theme product-info fallback
    else if (pInfo) {
      pInfo.appendChild(el);
    }
    // 4) PageFly: place above tabs row (fallback)
    else if (pfTabs && pfTabs.parentNode) {
      pfTabs.parentNode.insertBefore(el, pfTabs);
    }
    // 5) Other fallbacks near swatches/price/root
    else if (pfSwatches && pfSwatches.parentNode) {
      pfSwatches.parentNode.insertBefore(el, pfSwatches.nextSibling);
    } else if (pfPrice && pfPrice.parentNode) {
      pfPrice.parentNode.insertBefore(el, pfPrice.nextSibling);
    } else if (pfRoot) {
      pfRoot.appendChild(el);
    } else {
      (document.body || document.documentElement).appendChild(el);
    }

    if (__SKU_DEBUG__) {
      el.style.border = "1px dashed #d00";
      el.style.padding = "8px";
      el.style.background = "rgba(255,0,0,0.04)";
    }

    return el;
  }

  let __SKU_LAST_SKU__ = null;

  function updateBySku(sku) {
    // Non-system products: use Shopify description (static)
    if (typeof window.PRODUCT_IS_SYSTEM !== 'undefined' && window.PRODUCT_IS_SYSTEM === false) {
      const el = ensureContainer();
      if (!el) return;
      
      if (window.PRODUCT_DESCRIPTION) {
        el.innerHTML = '<h3 style="margin-bottom:12px;">Product Description</h3>' + window.PRODUCT_DESCRIPTION;
        el.style.display = "";
        debug("Rendered Shopify Description for non-system");
      } else {
        el.style.display = "none";
      }
      return;
    }

    // System products: ALWAYS use SKU-based description from JSON, never Shopify description
    if (typeof window.PRODUCT_IS_SYSTEM !== 'undefined' && window.PRODUCT_IS_SYSTEM === true) {
      if (!sku || sku === __SKU_LAST_SKU__) return;
      __SKU_LAST_SKU__ = sku;

      const el = ensureContainer();
      if (!el) return;

      // Look up description from SKU map (loaded from sku-descriptions.json)
      const html = window.__SKU_HTML_MAP__ && window.__SKU_HTML_MAP__[sku];
      if (html) {
        // Use the description from sku-descriptions.json, NOT Shopify's product.description
        // No h3 header for system products (content goes in "Included" tab which has its own header)
        el.innerHTML = html;
        el.style.display = "";
        debug("Rendered SKU-based HTML for System Product, SKU:", sku);
      } else {
        // No SKU match found - show debug info or hide
        const keysLen = Object.keys(window.__SKU_HTML_MAP__ || {}).length;
        el.innerHTML = __SKU_DEBUG__
          ? '<div style="font:12px/1.4 system-ui,Arial;color:#900">No content in sku-descriptions.json for SKU: <code>' +
            String(sku) +
            "</code>. Total loaded keys: " +
            keysLen +
            "</div>"
          : "";
        el.style.display = __SKU_DEBUG__ ? "" : "none";
        debug("No SKU match in JSON for System Product, SKU:", sku, "available keys:", keysLen);
      }
      return;
    }

    // Fallback for undefined PRODUCT_IS_SYSTEM (shouldn't normally happen)
    if (!sku || sku === __SKU_LAST_SKU__) return;
    __SKU_LAST_SKU__ = sku;

    const el = ensureContainer();
    if (!el) return;

    const html = window.__SKU_HTML_MAP__ && window.__SKU_HTML_MAP__[sku];
    if (html) {
      el.innerHTML = '<h3 style="margin-bottom:12px;">Product Description</h3>' + html;
      el.style.display = "";
      debug("Rendered HTML for SKU:", sku);
    } else {
      const keysLen = Object.keys(window.__SKU_HTML_MAP__ || {}).length;
      el.innerHTML = __SKU_DEBUG__
        ? '<div style="font:12px/1.4 system-ui,Arial;color:#900">No content for SKU: <code>' +
          String(sku) +
          "</code>. Loaded keys: " +
          keysLen +
          "</div>"
        : "";
      el.style.display = __SKU_DEBUG__ ? "" : "none";
      debug("No HTML found for SKU:", sku, "keys:", keysLen);
    }
  }

  // THEME: get current SKU from product-info / variant JSON
  function getThemeInitialSku() {
    const pInfo = document.querySelector("product-info");
    if (pInfo && pInfo.dataset && pInfo.dataset.currentSku) return pInfo.dataset.currentSku;

    try {
      const variantJsonEl = document.querySelector(
        'variant-selects [type="application/json"][data-all-variants]'
      );
      if (variantJsonEl) {
        const variants = JSON.parse(variantJsonEl.textContent);
        const idInput = document.querySelector('form input[name="id"]');
        const currentId = idInput ? parseInt(idInput.value, 10) : null;
        if (currentId) {
          const v = variants.find((x) => x.id === currentId);
          return (v && v.sku) || "";
        }
      }
    } catch (e) {
      debug("Theme initial SKU read failed:", e);
    }
    return "";
  }

  // PAGEFLY: resolve selected SKU (URL ?variant=, select options, or default)
  function getPageflySKU() {
    // Prefer active variant id from any product form
    const idInput = document.querySelector('form input[name="id"]');
    const activeId = idInput && idInput.value ? String(idInput.value) : "";

    const pf = window.__pageflyProducts;
    const ids = pf ? Object.keys(pf) : [];
    const prod = pf && ids.length ? pf[ids[0]] : null;

    // 1) URL variant param -> sku
    try {
      const url = new URL(window.location.href);
      const vid = url.searchParams.get("variant");
      if (vid && prod && Array.isArray(prod.variants)) {
        const found = prod.variants.find((v) => String(v.id) === String(vid));
        if (found && found.sku) return found.sku;
      }
    } catch (_) {
      /* ignore */
    }

    // 2) If we have an active variant id from the form, map it to SKU
    if (activeId && prod && Array.isArray(prod.variants)) {
      const found = prod.variants.find((v) => String(v.id) === String(activeId));
      if (found && found.sku) return found.sku;
    }

    // 3) From PageFly selects (exact option match)
    if (prod) {
      const swatchRoot = document.querySelector('[data-pf-type="ProductVariantSwatches"]');
      if (swatchRoot) {
        const selects = swatchRoot.querySelectorAll("select.pf-variant-select");
        const values = Array.from(selects).map((s) => (s.value || "").replace(/&quot;/g, '"'));
        if (prod.variants && values.length) {
          const v = prod.variants.find(
            (variant) => Array.isArray(variant.options) && variant.options.every((opt, i) => String(opt) === String(values[i]))
          );
          if (v && v.sku) return v.sku;
        }
      }
    }

    // 4) Fallbacks
    if (prod) {
      return (
        (prod.selected_or_first_available_variant && prod.selected_or_first_available_variant.sku) ||
        (prod.selected_variant && prod.selected_variant.sku) ||
        (Array.isArray(prod.variants) && prod.variants[0] && prod.variants[0].sku) ||
        ""
      );
    }
    return "";
  }

  function getSkuFromProductJson() {
    try {
      var path = (location && location.pathname) ? location.pathname.replace(/\/$/, '') : '';
      if (!path) return Promise.resolve('');
      return fetch(path + '.json', { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('product.json not found');
          return r.json();
        })
        .then(function (data) {
          var variants = (data && data.product && data.product.variants) || [];
          var first = variants[0] || null;
          var sku = (first && first.sku) || '';
          return sku || '';
        })
        .catch(function () { return ''; });
    } catch (_) {
      return Promise.resolve('');
    }
  }

  function wireListeners() {
    // Shopify theme pub/sub
    try {
      if (typeof subscribe === "function" && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
        subscribe(window.PUB_SUB_EVENTS.variantChange, (e) => {
          const sku = (e && e.data && e.data.variant && e.data.variant.sku) || "";
          if (sku && sku !== __SKU_LAST_SKU__) {
            debug("PUBSUB variantChange sku=", sku);
            updateBySku(sku);
          }
        });
      }
    } catch (err) {
      debug("subscribe not available", err);
    }

    // PageFly selects (change)
    document.addEventListener("change", (ev) => {
      if (ev && ev.target && ev.target.matches && ev.target.matches("select.pf-variant-select")) {
        // Debounce a bit to let PF update its state
        clearTimeout(wireListeners.__selTimer);
        wireListeners.__selTimer = setTimeout(() => {
          const sku = getPageflySKU();
          if (sku && sku !== __SKU_LAST_SKU__) {
            debug("PageFly select changed - sku=", sku);
            updateBySku(sku);
          }
        }, 150);
      }
    });

    // PageFly dynamic DOM: debounce mutation handling
    try {
      let moTimer = null;
      const mo = new MutationObserver(() => {
        clearTimeout(moTimer);
        moTimer = setTimeout(() => {
          const sku = getPageflySKU();
          if (sku && sku !== __SKU_LAST_SKU__) {
            debug("PageFly mutation observed - sku=", sku);
            updateBySku(sku);
          }
        }, 250);
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
    } catch (_) {
      // ignore
    }
  }

  function init(map) {
    window.__SKU_HTML_MAP__ = map || {};
    const keysLen = Object.keys(window.__SKU_HTML_MAP__).length;
    debug("Loaded keys:", keysLen);

    // Ensure container exists (visible with debug)
    ensureContainer();

    // Resolve initial SKU (prefer PageFly, fallback to Theme)
    const resolvedSku = getPageflySKU() || getThemeInitialSku();
    debug("Initial SKU resolved:", resolvedSku);
    if (resolvedSku) {
      updateBySku(resolvedSku);
      wireListeners();
      return;
    }

    // Fallback for products without visible variants or missing SKU
    getSkuFromProductJson().then(function (sku) {
      if (sku) {
        debug("Initial SKU via product.json:", sku);
        updateBySku(sku);
      } else {
        debug("No SKU available from product.json fallback");
      }
      wireListeners();
    });
  }

  // Prefer JSON (full set), fallback to CSV if JSON missing
  // Normalize JSON which may be either an array of records or a direct map
  function normalizeJsonToMap(data) {
    // If it's already a plain object map (key -> html), assume correct
    if (data && !Array.isArray(data) && typeof data === "object") {
      return data;
    }
    const map = {};
    if (Array.isArray(data)) {
      for (const row of data) {
        if (!row) continue;
        let key = (row.MPN ?? row.SKU ?? row.sku ?? "").toString().trim();
        let html = (row.Shopify_Description ?? row.description ?? row.html ?? "").toString();
        if (!key || !html) continue;
        // Last one wins on duplicate keys
        map[key] = html;
      }
    } else {
      throw new Error("Bad JSON");
    }
    return map;
  }

  const loadJSON = () =>
    fetch(JSON_URL)
      .then((r) => {
        if (!r.ok) throw new Error("JSON not found");
        return r.json();
      })
      .then((data) => normalizeJsonToMap(data));

  const loadCSV = () =>
    fetch(CSV_URL)
      .then((r) => {
        if (!r.ok) throw new Error("CSV not found");
        return r.text();
      })
      .then(parseCSV);

  if (typeof window.PRODUCT_IS_SYSTEM !== 'undefined' && window.PRODUCT_IS_SYSTEM === false) {
    // Skip fetching if not a system
    init({});
  } else {
    (JSON_URL ? loadJSON() : Promise.reject(new Error("No JSON URL")))
      .catch(() => (CSV_URL ? loadCSV() : Promise.reject(new Error("No data sources"))))
      .then(init)
      .catch((err) => {
        debug("SKU descriptions init failed:", err);
        if (__SKU_DEBUG__) {
          const el = ensureContainer();
          el.innerHTML =
            '<div style="color:#900;font:12px/1.4 system-ui,Arial">SKU data load error: ' + String(err) + "</div>";
          el.style.display = "";
        }
      });
  }
})();
